import React, { useEffect, useState } from 'react';

import Slider from 'react-slick';

import CasinoGamesCarouselItem from './CasinoGamesCarouselItem';

import GetCasinoGameResponse from 'casino/Api/CRM/Responses/CasinoGameResponse';
import CasinoSiteApi from 'casino/Api/SiteApi/CasinoSiteApi';
import Loader from 'components/loader/Loader';

function CasinoGamesCarouselList(props: { limit: number; casinoGameCategoryTranslationId: number }) {
    const [games, setGames] = useState<GetCasinoGameResponse[]>([]);
    const [isLoading, setLoading] = useState(true);

    const settings = {
        rows: 2,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 6000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 770,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2,
                    autoplay: true,
                },
            },
            {
                breakpoint: 510,
                settings: {
                    slidesToShow: 1,
                    autoplay: true,
                },
            },
        ],
    };

    async function getGames() {
        const { limit, casinoGameCategoryTranslationId } = props;
        CasinoSiteApi.games
            .getLimited(limit, casinoGameCategoryTranslationId)
            .then((gamesFromApi) => {
                if (gamesFromApi.length !== 0) {
                    setGames(gamesFromApi);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(function () {
        getGames();
    }, []);

    function getCarouselContent() {
        return (
            <Slider
                rows={settings.rows}
                dots={settings.dots}
                infinite={settings.infinite}
                speed={settings.speed}
                slidesToShow={settings.slidesToShow}
                slidesToScroll={settings.slidesToScroll}
                autoplay={settings.autoplay}
                autoplaySpeed={settings.autoplaySpeed}
                arrows={settings.arrows}
                responsive={settings.responsive}
            >
                {games.map((game) => (
                    <CasinoGamesCarouselItem key={game.id} game={game} />
                ))}
            </Slider>
        );
    }

    const getContent = () => {
        if (games.length === 0) {
            return null;
        }

        return <div className="container skeleton-container casino-games-list-wrapper">{getCarouselContent()}</div>;
    };

    return <Loader isLoading={isLoading} elementToShow={getContent} />;
}

export default CasinoGamesCarouselList;
